<template>
    <v-chip x-small color='teal lighten-1' text-color="white">Zewnętrzny</v-chip>
</template>

<script>
export default {
  name: "ChipExternal",
}
</script>